
export enum EnvelopeKind {
  LoanDocs = 'loan_docs',
  LoanModification = 'loan_modification'
}

export type EnvelopeRecord = {
  envelopeId: string
  timestamp: Date
  status: undefined | 'sent' | 'voided' | 'customer-signed' | 'draft'
  kind: EnvelopeKind
}